(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Orange list: roterande meddelanden ---------- */
  document.querySelectorAll('[data-announce]').forEach(function (bar) {
    var msgs = bar.querySelectorAll('.announce__msg');
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      var cur = msgs[i];
      cur.classList.remove('is-on'); cur.classList.add('is-out');
      setTimeout(function () { cur.classList.remove('is-out'); }, 600);
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-on');
    }, 3800);
  });

  /* ---------- Reveal vid scroll ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  document.querySelectorAll('.reveal').forEach(function (el) { io ? io.observe(el) : el.classList.add('is-in'); });

  /* ---------- Snö ---------- */
  function snow(host) {
    var c = host.querySelector('canvas.snow');
    if (!c || reduce) return;
    var ctx = c.getContext('2d'), flakes = [], w, h, dpr, running = false, raf;
    function size() {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = host.clientWidth; h = host.clientHeight;
      c.width = w * dpr; c.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.round(Math.min(160, w * h / 9000));
      flakes = [];
      for (var i = 0; i < n; i++) flakes.push(make(true));
    }
    function make(any) {
      var z = Math.random();
      return { x: Math.random() * w, y: any ? Math.random() * h : -10, r: 0.6 + z * 2.4, s: 0.35 + z * 1.4, d: Math.random() * 6.28, a: 0.25 + z * 0.6 };
    }
    function tick() {
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < flakes.length; i++) {
        var f = flakes[i];
        f.y += f.s; f.d += 0.01; f.x += Math.sin(f.d) * 0.4 + 0.15;
        if (f.y > h + 10 || f.x > w + 10) flakes[i] = make(false);
        ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, 6.283);
        ctx.fillStyle = 'rgba(255,240,228,' + f.a + ')'; ctx.fill();
      }
      raf = requestAnimationFrame(tick);
    }
    size(); window.addEventListener('resize', size);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        if (e[0].isIntersecting && !running) { running = true; tick(); }
        else if (!e[0].isIntersecting && running) { running = false; cancelAnimationFrame(raf); }
      }).observe(host);
    } else tick();
  }
  document.querySelectorAll('[data-snow]').forEach(snow);

  /* ---------- Värmezoner ---------- */
  document.querySelectorAll('[data-zones]').forEach(function (sec) {
    var glow = sec.querySelector('[data-glow]'), halo = sec.querySelector('[data-halo]'), temp = sec.querySelector('[data-temp]');
    var btns = sec.querySelectorAll('[data-level]');
    var op = [0, 0.5, 0.78, 1];
    function set(l, animateNum) {
      btns.forEach(function (b) { b.setAttribute('aria-checked', String(b.getAttribute('data-level') == l)); });
      glow.style.opacity = op[l];
      glow.style.filter = 'saturate(' + (0.7 + l * 0.1) + ') brightness(' + (0.85 + l * 0.05) + ')';
      if (halo) halo.style.opacity = op[l];
      var t = btns[l].getAttribute('data-t');
      if (!animateNum || t === '–') { temp.textContent = t; return; }
      var to = parseInt(t, 10), from = parseInt(temp.textContent, 10) || 0, st = performance.now();
      (function step(now) {
        var p = Math.min(1, (now - st) / 700);
        temp.textContent = Math.round(from + (to - from) * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(step);
      })(st);
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { set(+b.getAttribute('data-level'), true); }); });
    set(0, false);
    var lit = false;
    var start = function () {
      if (lit) return; lit = true;
      var l = 0;
      (function next() { l++; set(l, true); if (l < 3) setTimeout(next, 650); })();
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e, o) { if (e[0].isIntersecting) { setTimeout(start, 400); o.disconnect(); } }, { threshold: 0.4 }).observe(sec);
    } else set(3, false);
  });

  /* ---------- Galleri ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var track = g.querySelector('[data-track]'), thumbs = g.querySelectorAll('[data-thumbs] button');
    var slides = track.children;
    function go(i) { i = (i + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); }
    function cur() { return Math.round(track.scrollLeft / track.clientWidth); }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    var p = g.querySelector('[data-prev]'), n = g.querySelector('[data-next]');
    if (slides.length < 2) { if (p) p.hidden = true; if (n) n.hidden = true; }
    if (p) p.addEventListener('click', function () { go(cur() - 1); });
    if (n) n.addEventListener('click', function () { go(cur() + 1); });
    var mark = function () { var c = cur(); thumbs.forEach(function (t, i) { t.setAttribute('aria-current', String(i === c)); }); };
    track.addEventListener('scroll', function () { clearTimeout(track._t); track._t = setTimeout(mark, 60); });
    mark();
  });

  /* ---------- Paketväljare + köp ---------- */
  function money(cents, fmt) {
    fmt = fmt || '{{amount}} kr';
    var v = (cents / 100);
    var two = v.toFixed(2).split('.');
    var int = two[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals' || k === 'amount_no_decimals_with_comma_separator') return Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, k.indexOf('comma') > -1 ? '.' : ' ');
      if (k === 'amount_with_comma_separator') return int + ',' + two[1];
      return two[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + two[1];
    });
  }
  function bumpCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }

  document.querySelectorAll('[data-pdp]').forEach(function (pdp) {
    var form = pdp.querySelector('[data-offer]');
    if (!form) return;
    var tiers = form.querySelectorAll('[data-tier]');
    var btn = form.querySelector('[data-atc]'), sum = form.querySelector('[data-atc-sum]'), err = form.querySelector('[data-error]');
    var fmt = pdp.getAttribute('data-money');
    function active() {
      for (var i = 0; i < tiers.length; i++) { var r = tiers[i].querySelector('input[type=radio]'); if (!r || r.checked) return tiers[i]; }
      return tiers[0];
    }
    function render() {
      tiers.forEach(function (t) { var r = t.querySelector('input[type=radio]'); t.classList.toggle('is-on', !!(r && r.checked)); });
      var a = active();
      var q = a ? (parseInt(a.getAttribute('data-qty'), 10) || 1) : 1;
      var add = form.querySelector('[data-addon]'), on = add && add.querySelector('[data-addon-check]').checked;
      if (add) { add.classList.toggle('is-on', !!on); var ea = add.querySelector('[data-addon-each]'); if (ea) ea.hidden = q < 2; }
      var txt = '';
      if (a) {
        var tot = a.querySelector('[data-total]'), cents = parseInt(a.getAttribute('data-cents'), 10);
        txt = tot ? tot.textContent.trim() : '';
        if (on && !isNaN(cents)) txt = Math.round((cents + q * parseInt(add.getAttribute('data-price'), 10)) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr';
      }
      if (sum) sum.textContent = (q > 1 ? q + ' västar · ' : '') + (on ? '+ powerbank · ' : '') + txt;
      var sp = pdp.querySelector('[data-sticky-price]');
      if (sp && txt) sp.textContent = txt;
    }
    if (tiers.length && !form.querySelector('input[name=tier]:checked')) { var f = form.querySelector('input[name=tier]'); if (f) f.checked = true; }
    form.addEventListener('change', render);
    render();

    // synka storlek: första valet följer med till nya paket
    form.addEventListener('change', function (e) {
      if (!e.target.matches('select[data-variant]')) return;
      var val = e.target.value;
      tiers.forEach(function (t) { if (!t.contains(e.target)) { var s = t.querySelector('select[data-variant]'); if (s && !s.dataset.touched) s.value = val; } });
      e.target.dataset.touched = '1';
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var a = active(); if (!a) return;
      var items = {}, list = [];
      var sels = a.querySelectorAll('select[data-variant]');
      if (sels.length) sels.forEach(function (s) { items[s.value] = (items[s.value] || 0) + 1; });
      else { var d = form.querySelector('[data-default-variant]'); if (d) items[d.value] = parseInt(a.getAttribute('data-qty'), 10) || 1; }
      Object.keys(items).forEach(function (id) { list.push({ id: +id, quantity: items[id] }); });
      if (!list.length) return;
      var add = form.querySelector('[data-addon]');
      if (add && add.querySelector('[data-addon-check]').checked) list.push({ id: +add.getAttribute('data-variant-id'), quantity: parseInt(a.getAttribute('data-qty'), 10) || 1 });
      btn.disabled = true; err.hidden = true;
      var label = btn.querySelector('[data-atc-label]'), old = label.textContent; label.textContent = 'Lägger till…';
      fetch(pdp.getAttribute('data-add-url'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: list }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          window.location.href = pdp.getAttribute('data-after') === 'checkout' ? '/checkout' : pdp.getAttribute('data-cart-url');
        })
        .catch(function (j) {
          err.textContent = (j && (j.description || j.message)) || 'Något gick fel. Försök igen.';
          err.hidden = false; btn.disabled = false; label.textContent = old;
        });
    });

    // klistrig köpknapp på mobil
    var sticky = pdp.querySelector('[data-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      sticky.hidden = false; sticky.style.transform = 'translateY(140%)'; sticky.style.transition = 'transform .35s';
      new IntersectionObserver(function (e) {
        var below = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
        sticky.style.transform = below ? 'none' : 'translateY(140%)';
      }).observe(btn);
    }
  });
})();
/* sidomeny */
(function(){var d=document.querySelector('[data-side]');if(!d)return;
d.querySelectorAll('[data-side-close]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();d.removeAttribute('open')})});
d.querySelectorAll('.side__nav a').forEach(function(a){a.addEventListener('click',function(){d.removeAttribute('open')})});
document.addEventListener('keydown',function(e){if(e.key==='Escape')d.removeAttribute('open')});
d.addEventListener('toggle',function(){document.documentElement.style.overflow=d.open?'hidden':''})})();

/* stäng produktmenyn vid klick utanför */
document.addEventListener('click',function(e){document.querySelectorAll('.navdrop[open]').forEach(function(d){if(!d.contains(e.target))d.removeAttribute('open')})});
